import React from "react";
import { Box, Divider, Typography } from "@mui/material";

export const FooterOne = ({ translate }) => {
  return (
    <Box>
      <Box>
        <Typography variant="h6">
          <b>{translate("aboutUs")}</b>
        </Typography>
      </Box>
      <Divider sx={{ border: "2px solid #669944", width: "160px", my: 1 }} />
      <Box>
        <Typography variant="body2" py={1}>
          {translate("aboutUsFooter")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: { lg: "column", xl: "flex" },
          justifyContent: { xl: "center" },
          alignItems: { lg: "center" },
          paddingY: "10px",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <img
            src="/images/SBP_CONLogo_trans.png"
            alt="logo company"
            width="80vw"
            height="80vh"
          />
        </Box>
        <Box
          sx={{
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ ml: "10px" }}>
            <b>{translate("TITLE")}</b>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
